/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Collapse, Container } from 'reactstrap'
import { Link } from 'react-router-dom'
import classname from 'classnames'
import outlookIcon from '../../assets/icons/microsoft/outlook.png'
import onedriveIcon from '../../assets/icons/microsoft/onedrive.png'
import wordIcon from '../../assets/icons/microsoft/word.png'
import excelIcon from '../../assets/icons/microsoft/excel.png'
import powerpointIcon from '../../assets/icons/microsoft/powerpoint.png'
import sharepointIcon from '../../assets/icons/microsoft/sharepoint.png'
import teamsIcon from '../../assets/icons/microsoft/teams.png'
import ChatOikosButton from '../ChatOikos/ChatOikosButton'

class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    let matchingMenuItem = null
    const ul = document.getElementById('navigation')
    const items = ul ? ul.getElementsByTagName('a') : false
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location?.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({})
    }
  }

  activateParentDropdown = item => {
    item.classList.add('active')
    const parent = item.parentElement
    if (parent) {
      parent.classList.add('active')
      const parent2 = parent.parentElement
      parent2.classList.add('active')
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add('active')
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add('active')
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add('active')
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add('active')
            }
          }
        }
      }
    }
    return false
  }

  render() {
    const { user } = this.props.auth

    console.log('user', user)

    const onedriveMailPath = user ? this.props.auth.user.mail.replaceAll(/[@.]/g, '_') : false

    return (
      <>
      {user && (
      <>
        <div className="topnav">
          <Container fluid>
            <nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
              <Collapse isOpen={this.props.menuOpen} className="navbar-collapse" id="topnav-menu-content">
                <ul className="navbar-nav">


                  {/*
                  <li className="nav-item">
                    <Link className="nav-link" to="/agenda">
                      <i className="ri-calendar-event-line mr-2" />
                      Agenda
                    </Link>
                  </li>
                  */
                  }

                  <li className="nav-item dropdown">
                    <Link
                      onClick={e => {
                        e.preventDefault()
                        //this.setState({ rh: !this.state.rh })
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-more"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="ri-user-3-line mr-2" />
                      RH
                      {' '}
                      <div className="arrow-down" />
                    </Link>
                    <div className={classname('dropdown-menu', { show: this.state.rh })} aria-labelledby="topnav-more">
                      {user.perm_id === 1 && (
                        <Link to="/recursos-humanos/dashboard" className="dropdown-item">Dashboard</Link>
                      )}
                      <Link to="/recursos-humanos/justificativa-de-ausencia" className="dropdown-item">Justificativa de ausência</Link>
                      <Link to="/recursos-humanos/ponto-retroativo" className="dropdown-item">Ponto retroativo</Link>
                      <Link to="/recursos-humanos/relatorio-de-atividades" className="dropdown-item">Relatório de atividades</Link>
                      <Link to="/recursos-humanos/solicitacao-de-ferias" className="dropdown-item">Registro de férias</Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      onClick={e => {
                        e.preventDefault()
                        //this.setState({ patrimonio: !this.state.patrimonio })
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-more"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="ri-community-line mr-2" />
                      Patrimônio
                      {' '}
                      <div className="arrow-down" />
                    </Link>
                    <div className={classname('dropdown-menu', { show: this.state.patrimonio })} aria-labelledby="topnav-more">
                      <Link to="/patrimonio/aquisicao-e-manutencao" className="dropdown-item">Aquisição/Manutenção de Equipamentos</Link>
                      <Link to="/patrimonio/chamados-de-ti" className="dropdown-item">Chamados de TI</Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      onClick={e => {
                        e.preventDefault()
                        //this.setState({ projetos: !this.state.projetos })
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-more"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="ri-article-line mr-2" />
                      Dep. técnico
                      {' '}
                      <div className="arrow-down" />
                    </Link>
                    <div className={classname('dropdown-menu', { show: this.state.projetos })} aria-labelledby="topnav-more">
                      <Link to="/dep-tecnico/projetos" className="dropdown-item">Projetos</Link>
                      <Link to="/dep-tecnico/produtos" className="dropdown-item">Produtos</Link>
                      {/* <Link to="/dep-tecnico/portifolio-de-projetos" className="dropdown-item">Portifolio de Projetos</Link>*/}
                      {/* <Link to="/dep-tecnico/solicitacao-pagamento" className="dropdown-item">Solicitação de pagamento</Link> */}
                    </div>
                  </li>

                  {(user.perm_id === 1 || user.perm_id === 3 || user.perm_id === 2) && (
                    <>
                      <li className="nav-item dropdown">
                        <Link
                          onClick={e => {
                            e.preventDefault()
                            //this.setState({ comercial: !this.state.comercial })
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                          to="/#"
                          id="topnav-more"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="ri-shopping-cart-line mr-2" />
                          Comercial
                          {' '}
                          <div className="arrow-down" />
                        </Link>
                        <div className={classname('dropdown-menu', { show: this.state.comercial })} aria-labelledby="topnav-more">
                          <Link to="/comercial/privado" className="dropdown-item">Comercial</Link>
                          <Link to="/comercial/contratos" className="dropdown-item">Contratos</Link>
                          <Link to="/comercial/pesquisadesatisfacao" className="dropdown-item">Pesquisa de satisfação</Link>
                          <Link to="/comercial/acompanhamento" className="dropdown-item">Orçamentação</Link>
                        </div>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          onClick={e => {
                            e.preventDefault()
                            //this.setState({ financial: !this.state.financial })
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                          to="/#"
                          id="topnav-more"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="ri-money-dollar-circle-line mr-2" />
                          Financeiro
                          {' '}
                          <div className="arrow-down" />
                        </Link>
                        <div className={classname('dropdown-menu', { show: this.state.financial })} aria-labelledby="topnav-more">
                          {(user.perm_id === 1) &&
                            <>
                              <Link to="/dashboardfinancial" className="dropdown-item">Dashboard</Link>
                              {/*
                              <Link to="/orcamento" className="dropdown-item">Orçamento</Link>
                              */}
                              <Link to="/financeiro/orcamento-dashboard" className="dropdown-item">Dashboard Orçamentário</Link>
                              <Link to="/bordero" className="dropdown-item">Bordero</Link>
                              <Link to="/receitas" className="dropdown-item">Receitas</Link>
                            </>
                          }
                          {(user.perm_id === 3 || user.perm_id === 2) &&
                            <>
                              <Link to="/financeiro/orcamento-dashboard" className="dropdown-item">Dashboard Orçamentário</Link>
                              <Link to="/bordero" className="dropdown-item">Bordero</Link>
                            </>
                          }
                        </div>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          onClick={e => {
                            e.preventDefault()
                            //this.setState({ gerencia: !this.state.gerencia })
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                          to="/#"
                          id="topnav-more"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="ri-team-line mr-2" />
                          Gerência
                          {' '}
                          <div className="arrow-down" />
                        </Link>
                        <div className={classname('dropdown-menu', { show: this.state.gerencia })} aria-labelledby="topnav-more">
                          <Link to="/gerencia/solicitacoes" className="dropdown-item">Solicitações</Link>
                          <Link to="/gerencia/atestados" className="dropdown-item">Atestados</Link>
                          <Link to="/gerencia/solicitacao-juridica" className="dropdown-item">Solicitação Jurídica</Link>
                          <Link to="/gerencia/oficios" className="dropdown-item">Ofícios</Link>
                        </div>
                      </li>
                    </>
                  )}
                </ul>
              </Collapse>
            </nav>
          </Container>
        </div>
        { user.perm_id === 1 && (
        <>
          <ChatOikosButton />
        </>
        )}
        </>
      )}
      </>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(Navbar)